var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('n-card',{attrs:{"more":true,"title":"Skill Cloud"}},[_c('div',{staticClass:"chart-worldcloud-box"},[_c('ve-wordcloud',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c1b13b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/skill-card.vue
// module id = null
// module chunks = 